angular.module( 'acme.view.application.scheduler.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.scheduler.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var schedulerDetail = {
        name: 'application.scheduler.detail',
        url: '/detail',
        views: {
          "subview-main": {
            controller: 'SchedulerDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/scheduler/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'Scheduler'
        },
        resolve: {
            gantt: ['$q', function($q) {
                // Load scripts sequentially since extensions depend on base library
                return $q.when($.cachedScript( "/assets/dhtmlxgantt.js" ))
                    .then(function() {
                        // Load extensions in parallel after base library is loaded
                        return $q.all([
                            $q.when($.cachedScript( "/assets/dhtmlxgantt_undo.js" )),
                            $q.when($.cachedScript( "/assets/dhtmlxgantt_keyboard_navigation.js" ))
                        ]);
                    })
                    .then(function() {
                        return 'done';
                    })
                    .catch(function(error) {
                        console.error('Failed to load gantt scripts:', error);
                        throw error;
                    });
            }]
        }
      };

    $stateProvider
      .state(schedulerDetail);
})
.filter('ellipsis', function () {
    return function (input) {
        if (input) {
            if ( input.length > 30) {
                return input.substring(0, 30) + '...';
            }
            return input;
        }
    };
});